import { Alert, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, InputLabel, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, Tooltip, Typography, Modal, Backdrop, Fade } from "@mui/material";
import { useEffect, useState } from "react";
import axios from 'axios';
import { hospitalsApplyFormProps, requiredHospitalsApplyFormProps } from "../../consts/form-helpers/form-consts";
import { hospitalApply, verifyCaptcha, getHospitalDetailsByHash, editHospital, getHospitalEmail, getHospitalEditPin } from "../../services/apply-service";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './request-support-apply.css';
import { customHasher } from "../../consts/helpers/customHasher";

const RequestSupportApplyComponent = () => {
    const HCAPTCHA_KEY = 'fb4046c2-1f94-4212-af88-f88274f21c4e';
    const [selectedFields, setSelectedFields] = useState([]);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [confirmInformationIsTrue, setConfirmInformationIsTrue] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);
    const [error, setError] = useState(null);
    const [emailError, setEmailError] = useState(false);
    const [emptyFormProps, setEmptyFormProps] = useState([]);
    const [acceptTermsError, setAcceptTermsError] = useState('');
    const [confirmInformationIsTrueError, setConfirmInformationIsTrueError] = useState('');
    const [formData, setFormData] = useState({ ...hospitalsApplyFormProps });
    const [isSuccess, setIsSuccess] = useState(false);
    const [captchaToken, setCaptchaToken] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [emailHash, setEmailHash] = useState(false);
    const [fieldsToUpdate, setFieldsToUpdate] = useState({});
    const [isFieldOfExpertiseEdited, setIsFieldOfExpertiseEdited] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [enteredEmail, setEnteredEmail] = useState("");
    const [enteredPin, setEnteredPin] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [validationError, setValidationError] = useState("");



    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (window.location.search !== '') {
            setIsEdit(true);
            const hash = new URLSearchParams(window.location.search).get('h');
            setEmailHash(hash);

            getHospitalDetailsByHash(hash)
                .then(res => {
                    console.log('Hospital data:', res);
                    const expertiseIds = res.fields_of_expertise?.map(item => item.id) || [];
                    setFormData({ ...res, field_of_expertise_ids: expertiseIds });
                    setAcceptTerms(res.terms_and_conditions === true);
                    setConfirmInformationIsTrue(res.information_accuracy_confirmation === true);
                    setSelectedFields(expertiseIds);

                    setIsModalOpen(true);
                }).catch(err => console.log("An error occured", err))

        }
    }, []);

    const handleCaptchaVerify = token => {
        setError(null);
        setCaptchaToken(token);
    };

    const handleInputChange = e => {
        setError(null);
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, [e.target.name]: e.target.value })
        }

        if (emptyFormProps.includes(e.target.name)) {
            setEmptyFormProps((props) => props.filter(prop => prop !== e.target.name));
        }
    };

    const handleAcceptTermsChange = (isChecked) => {
        setAcceptTerms(isChecked);
        setFormData(prev => ({
            ...prev,
            terms_and_conditions: isChecked
        }));
        if (isEdit) {
            setFieldsToUpdate(prev => ({
                ...prev,
                terms_and_conditions: isChecked
            }));
        }
        if (isChecked) setAcceptTermsError('');
    };

    const handleConfirmInformationIsTrue = (isChecked) => {
        setConfirmInformationIsTrue(isChecked);
        setFormData(prev => ({
            ...prev,
            information_accuracy_confirmation: isChecked
        }));
        if (isEdit) {
            setFieldsToUpdate(prev => ({
                ...prev,
                information_accuracy_confirmation: isChecked
            }));
        }
        if (isChecked) setConfirmInformationIsTrueError('');
    };
    const handleFieldChange = (e) => {
        setError(null);
        const value = e.target.value;

        // Remove error if previously missing
        setEmptyFormProps((props) => props.filter(prop => prop !== 'field_of_expertise_ids'));

        // Set form and visual state
        setSelectedFields(value);
        setFormData(prev => ({ ...prev, field_of_expertise_ids: value }));

        // Mark as edited so backend includes it
        if (isEdit) {
            setIsFieldOfExpertiseEdited(true);
        }
    };

    const validateForm = () => {
        let isFormValid = true;

        for (let prop of requiredHospitalsApplyFormProps) {
            if (formData[prop] === '' || formData[prop] === null || formData[prop] === false) {
                if (prop === 'terms_and_conditions') {
                    setAcceptTermsError('You must accept the terms and conditions to procede.')
                    isFormValid = false;
                };

                if (prop === 'information_accuracy_confirmation') {
                    setConfirmInformationIsTrueError('You must confirm the accuracy of information provided.')
                    isFormValid = false;
                };

                setEmptyFormProps((prev) => [...prev, prop]);
                setError('Please fill out all required fields');
                isFormValid = false;
            };

            if (prop === 'terms_and_conditions' && !acceptTerms) {
                setAcceptTermsError('You must accept the terms and conditions to procede.');
                setError('Please fill out all required fields');
                isFormValid = false;
            };

            if (prop === 'information_accuracy_confirmation' && !confirmInformationIsTrue) {
                setConfirmInformationIsTrueError('You must confirm the accuracy of information provided.');
                setError('Please fill out all required fields');
                isFormValid = false;
            };
        };

        return isFormValid;
    }

    const handleSubmit = async () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (validateForm()) {
            verifyCaptcha({ token: captchaToken }).then((res) => {
                if (res.success) {
                    if (isEdit) {
                        const editedData = {
                            id: formData.id,
                            fieldsToUpdate
                        };

                        if (isFieldOfExpertiseEdited) {
                            editedData.field_of_expertise_ids = formData.field_of_expertise_ids;
                        }
                        console.log('Edited data:', editedData)

                        editHospital(editedData).then(res => {
                            console.log(res);
                            setIsSuccess(true);
                            setSuccessMessage('Your application was succesfully edited. You will be contacted for further details.');

                        }).catch(err => console.log(err));
                    } else {
                        hospitalApply(formData).then((res) => { }).catch(er => console.log(er));
                        setIsSuccess(true);
                        setSuccessMessage('Thank you. Your application was successfully sent. You will be contacted for further details.');

                    }
                } else {
                    setError('Captcha verification failed. Please try again.');
                }
            })
        }
    }



    const handleEmailBlur = () => { setEmailError(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? 'Invalid email format' : '') };

    useEffect(() => {
        setError(null);

        axios.get('https://restcountries.com/v3.1/all?fields=name,flags')
            .then((response) => {
                const newCountries = response.data.map(country => ({
                    label: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    value: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    flag: country.flags.png
                }));

                newCountries.sort((a, b) => a.label.localeCompare(b.label));

                setCountryOptions(newCountries);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleVerify = async () => {
        try {
            const responseEmail = await getHospitalEmail(formData.id);
            const responsePin = await getHospitalEditPin(formData.id);

            // Convert email to lowercase and trim spaces
            const storedEmail = responseEmail.email.trim().toLowerCase();
            const enteredEmailFormatted = enteredEmail.trim().toLowerCase();

            // Convert PIN to a string and trim spaces
            const storedPin = String(responsePin.hospital_pin_edit).trim();
            const enteredPinFormatted = enteredPin.trim();

            // Compare emails and PINs after proper formatting
            if (storedEmail === enteredEmailFormatted && storedPin === enteredPinFormatted) {
                setIsAuthenticated(true);
                setIsModalOpen(false); // Close the modal
            } else {
                setValidationError("Invalid email or PIN. Please try again.");
            }
        } catch (error) {
            setValidationError("Error verifying credentials. Please try again.");
        }
    };

    //TODO - CHANGE THE 3 HARDCODED COLLECTIONS BELOW WITH A GET CALL FROM THE DB!

    const level = [
        {
            value: 1,
            label: 'Secondary',
        },
        {
            value: 2,
            label: 'Tertiary'
        },
        {
            value: 3,
            label: 'Academic'
        },
        {
            value: 4,
            label: 'Local'
        }
    ];

    const type = [
        {
            value: 1,
            label: 'Public'
        },
        {
            value: 2,
            label: 'Private, non-profit'
        },
        {
            value: 3,
            label: 'Private, for-profit'
        }
    ];

    const fieldsOfExpertise = [
        {
            value: 1,
            label: 'Infectious diseases management'
        },
        {
            value: 2,
            label: 'Clinical microbiology'
        },
        {
            value: 3,
            label: 'Diagnostic stewardship and laboratory services'
        },
        {
            value: 4,
            label: 'Infection prevention and control'
        },
        {
            value: 5,
            label: 'Antimicrobial Stewardship'
        }
    ];

    return (
        <div style={{ filter: isEdit && !isAuthenticated ? 'blur(6px)' : 'none', pointerEvents: isEdit && !isAuthenticated ? 'none' : 'auto' }}>
            <div className="content-rsa">
                <p>
                    We are happy to receive your request for support and work with you towards high quality infectious disease care everywhere.
                </p>
                <p>
                    By filling out the form below, we can gain an understanding of your needs and the context you work in. We will review your application, and get back in touch with you regarding the matching procedure as soon as possible.
                </p>
                <p>
                    If you have any questions in the meantime, please don’t hesitate to reach out to our SPICE Coordinator at <a href="miriam.sijtsma@radboudumc.nl">miriam.sijtsma@radboudumc.nl</a>
                </p>
            </div>
            {isSuccess ? (
                <div className="success-msg-rsa-div">
                    <Alert className="success-msg-alert-rsa" severity="success">
                        <strong><h3>{successMessage}</h3></strong>
                    </Alert>
                </div>
            ) : (
                <>
                    <Typography variant="h4" color={'primary'} m={2.5} textAlign={'center'}>Request Support</Typography>
                    <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        className="content-rsa-form"
                    >


                        <Grid container spacing={2}>
                            <Typography variant="h6" color={'primary'} textAlign={'center'}>Hospital/Institution info</Typography>
                            <Grid item xs={12}>
                                <TextField
                                    label="Hospital/institution name"
                                    id="outlined-size-small"
                                    name="name"
                                    value={formData.name}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('name') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('name')}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Address"
                                    id="outlined-size-small"
                                    name="address"
                                    value={formData.address}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('address') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('address')}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="City"
                                    id="outlined-size-small"
                                    name="city"
                                    value={formData.city}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('city') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('city')}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-select-country"
                                    name="country"
                                    select
                                    label="Country"
                                    value={formData.country}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('country') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('country')}
                                >
                                    {countryOptions.map((option) => (
                                        <MenuItem sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.value} value={option.value}>
                                            <img
                                                loading="lazy"
                                                width="20"
                                                srcSet={option.flag}
                                                src={option.flag}
                                                alt=""
                                            />
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Legal representative/authorized person"
                                    id="outlined-size-small"
                                    name="legal_representative_authorized_person"
                                    value={formData.legal_representative_authorized_person}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('legal_representative_authorized_person') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('legal_representative_authorized_person')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Position"
                                    id="outlined-size-small"
                                    name="legal_representative_authorized_person_position"
                                    value={formData.legal_representative_authorized_person_position}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('legal_representative_authorized_person_position') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('legal_representative_authorized_person_position')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Contact person"
                                    id="outlined-size-small"
                                    name="contact_person"
                                    value={formData.contact_person}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('contact_person') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('contact_person')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Position"
                                    id="outlined-size-small"
                                    name="contact_person_position"
                                    value={formData.contact_person_position}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('contact_person_position') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('contact_person_position')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Phone number"
                                    id="outlined-size-small"
                                    name="phone_number"
                                    value={formData.phone_number}
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('phone_number') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('phone_number')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Email"
                                    id="outlined-size-small"
                                    name="email"
                                    value={formData.email}
                                    size="small"
                                    fullWidth
                                    type="email"
                                    helperText={emailError !== '' ? emailError : emptyFormProps.includes('email') ? 'This field is required' : ''}
                                    error={!!emailError || !!emptyFormProps.includes('email')}
                                    onBlur={handleEmailBlur}
                                    onChange={e => handleInputChange(e)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    placeholder="Briefly describe size, types of specialties, population coverage, etc"
                                    label="About the hospital"
                                    id="outlined-size-small"
                                    name="about_the_hospital"
                                    multiline
                                    value={formData.about_the_hospital}
                                    rows={5}
                                    maxRows={10}
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('about_the_hospital') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('about_the_hospital')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="outlined-select-level"
                                    name="institution_level_id"
                                    select
                                    value={formData.institution_level_id}
                                    label="Level"
                                    defaultValue=""
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('institution_level_id') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('institution_level_id')}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    {level.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="outlined-select-country"
                                    name="institution_type_id"
                                    select
                                    value={formData.institution_type_id}
                                    label="Type"
                                    defaultValue=""
                                    size="small"
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('institution_type_id') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('institution_type_id')}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    {type.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Typography variant="h6" color={'primary'} mt={5} textAlign={'center'}>Requested expert support</Typography>
                            <Grid item xs={12}>
                                <FormControl fullWidth error={!!emptyFormProps.includes('field_of_expertise_ids')}>
                                    <InputLabel id="field-of-expertise-label">Field of Expertise</InputLabel>
                                    <Select
                                        labelId="field-of-expertise-label"
                                        id="fields_of_expertise"
                                        multiple
                                        value={formData.field_of_expertise_ids || []}
                                        onChange={handleFieldChange}
                                        renderValue={(selected) => selected.map(value => {
                                            const option = fieldsOfExpertise.find(opt => opt.value === value);
                                            return option ? option.label : '';
                                        }).join(', ')}
                                        size="large"
                                    >
                                        {fieldsOfExpertise.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                <Checkbox checked={selectedFields.indexOf(option.value) > -1} />
                                                <ListItemText primary={option.label} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {emptyFormProps.includes('field_of_expertise_ids') && (<FormHelperText>This field is required</FormHelperText>)}

                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormHelperText>What is the reason for your request for support?</FormHelperText>
                                <TextField
                                    placeholder="Briefly describe the requested support"
                                    label="Requested support description"
                                    id="outlined-size-small"
                                    name="requested_support_description"
                                    multiline
                                    value={formData.requested_support_description}
                                    rows={5}
                                    maxRows={10}
                                    fullWidth
                                    onChange={e => handleInputChange(e)}
                                    helperText={emptyFormProps.includes('requested_support_description') ? 'This field is required' : ''}
                                    error={!!emptyFormProps.includes('requested_support_description')}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} container>
                            <Grid item>
                                {acceptTermsError && (
                                    <FormHelperText>
                                        <b style={{ color: '#d32f2f' }}>{acceptTermsError}</b>
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container gap="10px" alignItems="center" justifyContent="space-between">
                            <Grid item>
                                <FormLabel component="legend">
                                    <small>
                                        <strong>We accept the terms and conditions of the SPICE expert support</strong>
                                    </small>
                                </FormLabel>
                            </Grid>
                            <Grid item>
                                <Checkbox
                                    value={formData.terms_and_conditions}
                                    checked={acceptTerms}
                                    onChange={(e) => handleAcceptTermsChange(e.target.checked)}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container>
                            <Grid item>
                                {confirmInformationIsTrueError && (
                                    <FormHelperText>
                                        <b style={{ color: '#d32f2f' }}>{confirmInformationIsTrueError}</b>
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container gap="10px" alignItems="center" justifyContent="space-between">
                            <Grid item>
                                <FormLabel component="legend">
                                    <small>
                                        <strong>We confirm the above information is true</strong>
                                    </small>
                                </FormLabel>
                            </Grid>
                            <Grid item>
                                <Checkbox
                                    value={formData.information_accuracy_confirmation}
                                    checked={confirmInformationIsTrue}
                                    onChange={(e) => handleConfirmInformationIsTrue(e.target.checked)}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container gap="10px" alignItems="center" justifyContent="space-between">

                            <Grid item xs={12}>
                                <div style={{ display: 'flex', width: 'fit-content', alignSelf: 'flex-start' }}>
                                    <HCaptcha sitekey={HCAPTCHA_KEY} onVerify={handleCaptchaVerify} />
                                </div>
                            </Grid>

                            <Grid item xs={12} mt='25px' mb='25px'>
                                <FormLabel component="legend">
                                    <small>
                                        <strong style={{ color: '#1565C0' }}>
                                            After processing your request and upon matching with an expert, we will ask you for a letter of commitment from an authorized person from your institution.
                                        </strong>
                                    </small>
                                </FormLabel>
                                <FormLabel component="legend">
                                    <small>
                                        <strong style={{ color: '#1565C0' }}>
                                            If you agree to register, any processing of provided data will comply with EU Regulations 45/2001 and 2018/1725. As the host of the registry, Radboudumc is the main data controller of this processing operation.
                                        </strong>
                                    </small>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                    sx={{ textTransform: 'none', marginBottom: '2.5vh', backgroundColor: '#009E60', '&:hover': { backgroundColor: '#009E60' } }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                {error && (
                                    <Alert variant="filled" severity="error">
                                        Error: {error}
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>

                    </Box>
                    <Modal
                        open={isModalOpen}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{ timeout: 500 }}
                    >
                        <Fade in={isModalOpen}>
                            <Box sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 4,
                                borderRadius: 2,
                                width: "400px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 2
                            }}>
                                <Typography variant="h6" align="center">Authentication Required</Typography>

                                <TextField
                                    label="Email"
                                    fullWidth
                                    value={enteredEmail}
                                    onChange={(e) => setEnteredEmail(e.target.value)}
                                />

                                <TextField
                                    label="PIN"
                                    type="number"
                                    fullWidth
                                    value={enteredPin}
                                    onChange={(e) => setEnteredPin(e.target.value)}
                                />

                                {validationError && <Alert severity="error">{validationError}</Alert>}

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleVerify}
                                >
                                    Send
                                </Button>
                            </Box>
                        </Fade>
                    </Modal>
                </>
            )}
        </div>
    )
}

export default RequestSupportApplyComponent;